import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FirebaseService } from 'src/app/services/firebase.service';

@Component({
  selector: 'app-gracias-cotizador-empresa',
  templateUrl: './gracias-cotizador-empresa.component.html',
  styleUrls: ['./gracias-cotizador-empresa.component.scss']
})
export class GraciasCotizadorEmpresaComponent implements OnInit {

  idCotizacion;
  cotizacion;

  accesos = [
    'Acceso total al sistema web',
    'Acceso total al APP mobil',
    'Central de Emergencias 24x7x365',
    'Notificación de alertas y alarmas',
    'Recuperación de vehículos robados',
    'Flotas administrables',
    'Geo-cercas virtuales',
    'Multi usuarios a todo nivel',
    'Perfiles de conductor',
    'Reportes generales y personalizables',
    'Diversas cartografías',
    'Historial de datos (hasta 24 meses)',
    'Tracking para análisis de recorrido',
    'Integración con BD externos',
    'Soporte técnico 24x7',
    'Integración de diversos sensores'
  ];

  eventos = [
    'Motor encendido',
    'Motor apagado',
    'Aceleración brusca',
    'Frenado brusco',
    'Velocidad en curva',
    'Excesos de velocidad',
    'Detenido',
    'Estacionado',
    'Conduciendo',
    'Sobreparada',
    'Botón de pánico',
    'Batería desconectada',
  ];

  constructor(
    private fs: FirebaseService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe( params => {
      this.idCotizacion = params.id;

      this.fs.getCotizacionEmpresa(this.idCotizacion).subscribe(res => {
        this.cotizacion = res;
        console.log(JSON.stringify(this.cotizacion));
      });
    });
  }

}
